module.exports = __webpack_public_path__ + "static/media/baxi-logo.b3b46448.png";